import { render, staticRenderFns } from "./DealersDetails.vue?vue&type=template&id=3aaefea2&scoped=true"
import script from "./DealersDetails.vue?vue&type=script&lang=ts"
export * from "./DealersDetails.vue?vue&type=script&lang=ts"
import style0 from "./DealersDetails.vue?vue&type=style&index=0&id=3aaefea2&lang=scss"
import style1 from "./DealersDetails.vue?vue&type=style&index=1&id=3aaefea2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaefea2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aaefea2')) {
      api.createRecord('3aaefea2', component.options)
    } else {
      api.reload('3aaefea2', component.options)
    }
    module.hot.accept("./DealersDetails.vue?vue&type=template&id=3aaefea2&scoped=true", function () {
      api.rerender('3aaefea2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dealers/components/DealersDetails.vue"
export default component.exports